import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { tokenStore } from "./lib/api";
import { ConfirmProvider } from "./components/kit";
import Shell from "./components/Shell";
import Landing from "./pages/Landing";
import Gate from "./pages/Gate";
import Home from "./pages/Home";
const Calendar = lazy(() => import("./pages/Calendar"));
const Chores = lazy(() => import("./pages/Chores"));
const Finances = lazy(() => import("./pages/Finances"));
const Wishlist = lazy(() => import("./pages/Wishlist"));
const Sparrow = lazy(() => import("./pages/Sparrow"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Shopping = lazy(() => import("./pages/Shopping"));
const Scoreboard = lazy(() => import("./pages/Scoreboard"));
const Arcade = lazy(() => import("./pages/Arcade"));
const Fan = lazy(() => import("./pages/Fan"));
const Notifications = lazy(() => import("./pages/Notifications"));
const Settings = lazy(() => import("./pages/Settings"));
const Feedback = lazy(() => import("./pages/Feedback"));
const CreatorStandalone = lazy(() => import("./pages/CreatorStandalone"));

function Private() {
  const { me, loading } = useAuth();
  if (!tokenStore.get()) return <Navigate to="/" replace />;
  if (loading || !me) return <div className="min-h-screen" data-testid="app-loading" />;
  return <Gate><Shell /></Gate>;
}

function Public() {
  return tokenStore.get() ? <Navigate to="/home" replace /> : <Landing />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfirmProvider>
          <Suspense fallback={<div className="min-h-screen" data-testid="page-loading" />}>
          <Routes>
            <Route path="/" element={<Public />} />
            <Route path="/creator" element={<CreatorStandalone />} />
            <Route element={<Private />}>
              <Route path="/home" element={<Home />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/chores" element={<Chores />} />
              <Route path="/chores/:id" element={<Chores />} />
              <Route path="/finances" element={<Finances />} />
              <Route path="/finances/:id" element={<Finances />} />
              <Route path="/sparrow" element={<Sparrow />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/shopping" element={<Shopping />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/scoreboard" element={<Scoreboard />} />
              <Route path="/arcade" element={<Arcade />} />
              <Route path="/fan" element={<Fan />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/settings/:panel" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
          <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "var(--surface)", color: "var(--text)", border: "1px solid var(--border)" } }} />
        </ConfirmProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
